module.exports = __webpack_public_path__ + "operace-ocnich-vicek-horni_4_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-ocnich-vicek-horni_4_before.jpg
// module id = 1164
// module chunks = 0